jQuery(document).ready(function($){
	var breakpoint, menuBreakpoint, menuCollapsedBreakpoint;
	breakpoint = 720;
	menuCollapsedBreakpoint = breakpoint + 35;
	menuBreakpoint = menuCollapsedBreakpoint + 250;

	let addTargetTimeout;
	let allAddTargets = [];
	$('.menu-item-has-children').on('mouseover', function(){
		const el = $(this);
		const width = (window.innerWidth > 0) ? window.innerWidth : screen.width;
		if(!el.hasClass('hovered') && !isMobileMenu(width) && !isMegaSubmenu(el)) {
			clearTimeout(addTargetTimeout);
			allAddTargets = [];

			allAddTargets.push(el);

			addTargetTimeout = setTimeout(function(){
				if(!el.is(':hover')) return;

				console.log(allAddTargets);
				let selector = '';
				$.each(allAddTargets, function(){
					const uniqueSelector = getUniqueSelector($(this)[0]);
					if(uniqueSelector.length > selector.length) selector = uniqueSelector;
				});

				console.log(selector.length, selector);

				addNavHoverClass($(selector));
				setTimeout(function(){
					allAddTargets = [];
				}, 150);
			}, 150);
		}
	});

	let removeTargetTimeout;
	let allRemoveTargets = [];
	$('.menu-item-has-children').on('mouseleave', function(e){
		const el = $(this);
		var width = (window.innerWidth > 0) ? window.innerWidth : screen.width;
		if(el.hasClass('hovered') && !isMobileMenu(width) && !isMegaSubmenu(el)) {
			clearTimeout(removeTargetTimeout);
			allRemoveTargets = [];

			allRemoveTargets.push(el);

			removeTargetTimeout = setTimeout(function(){
				if(el.is(':hover')) return;

				console.log(allRemoveTargets);
				let selector = '';
				$.each(allRemoveTargets, function(){
					const uniqueSelector = getUniqueSelector($(this)[0]);
					if(uniqueSelector.length > selector.length) selector = uniqueSelector;
				});

				console.log(selector);

				removeNavHoverClass($(selector), true);
				setTimeout(function(){
					allRemoveTargets = [];
				}, 150);
			}, 150);
		}
	});

	$('.menu-item-has-children > a').on('click', function(e){
		//Return if clicking .caret-wrapper, as that is double clicking
		if($(e.target).hasClass('caret-wrapper')) return;
		if($(e.target).closest('.caret-wrapper').length) return;

		if($(this).attr('href') == '#') {
			if($(this).closest('.menu-item-has-children').hasClass('hovered')) {
				removeNavHoverClass($(this), false);
			} else {
				addNavHoverClass($(this));
			}
		}
	});

	$('.menu-item-has-children > a .caret-wrapper').on('click', function(e){
		e.preventDefault();
		if($(this).closest('.menu-item-has-children').hasClass('hovered')) {
			removeNavHoverClass($(this), false);
		} else {
			addNavHoverClass($(this));
		}
	});

	function getUniqueSelector(el) {
		if (!(el instanceof Element)) return;

		const parts = [];

		while (el && el.nodeType === 1 && el.tagName.toLowerCase() !== 'html') {
			let selector = el.tagName.toLowerCase();

			// Add classes if any
			if (el.className) {
				const classNames = [...el.classList].join('.');
				selector += `.${classNames}`;
			}

			// Add :nth-child to ensure uniqueness if necessary
			const parent = el.parentNode;
			if (parent) {
				const siblings = [...parent.children].filter(child => child.tagName === el.tagName);
				if (siblings.length > 1) {
					const index = siblings.indexOf(el) + 1;
					selector += `:nth-of-type(${index})`;
				}
			}

			parts.unshift(selector);
			el = el.parentNode;
		}

		return parts.join(' > ');
	}


	function isMobileMenu(width) {
		var widthToCheck;
		if($('body').hasClass('has-co-member-menu')) {
			widthToCheck = $('body').hasClass('co-member-menu-collapsed') ? menuCollapsedBreakpoint : menuBreakpoint;
		} else {
			widthToCheck = breakpoint;
		}

		return width <= widthToCheck;
	}

	function isMegaSubmenu(el) {
		let parentItems = el.parents('.menu-item-has-children.mega-menu');
		console.log(el);
		console.log(parentItems.length, parentItems);
		console.log(el.hasClass('mega-menu'));
		return parentItems.length && !el.hasClass('mega-menu');
	}

	let closeHoverClassTimer;
	function addNavHoverClass(el) {
		let closestItem = el.closest('.menu-item-has-children');
		let parentItems = el.parents('.menu-item-has-children');
		console.log(parentItems);
		$('.menu-item-has-children').each(function(){
			el = $(this);

			removeClass = true;
			if(el == closestItem) removeClass = false;
			parentItems.each(function(){
				if(el == $(this)) removeClass = false;
			});
			if(removeClass) $(this).removeClass('hovered');
		})
		closestItem.addClass('hovered');
		parentItems.addClass('hovered');
		clearTimeout(closeHoverClassTimer);
	}

	function removeNavHoverClass(el, delay) {
		let closestItem = el.closest('.menu-item-has-children');
		let parentItems = el.parents('.menu-item-has-children');

		// const hasChildHovered = el.find('.menu-item-has-children.hovered');

		// if(hasChildHovered.length) return;
		// console.log(hasChildHovered);
		console.log(closestItem);
		console.log(parentItems);

		if(delay) {
			closeHoverClassTimer = setTimeout(function(){
				if(closestItem.hasClass('hovered')) closestItem.removeClass('hovered');
				parentItems.removeClass('hovered');
			}, 150);
		} else {
			closestItem.removeClass('hovered');
			parentItems.removeClass('hovered');
		}
	}

	if($('#brand-top-header').length) {
		$('.brand-top-header .brands-hamburger-menu').on('click', function(){
			$('#brand-top-header').toggleClass('show-brand-menu');
		});

		$('a[href="#brand-top-header"]').on('click', function(){
			$('#brand-top-header').addClass('show-brand-menu');
		});
	}
});